import { render } from "./PlanesComponent.vue?vue&type=template&id=6036f126&scoped=true"
import script from "./PlanesComponent.vue?vue&type=script&lang=js"
export * from "./PlanesComponent.vue?vue&type=script&lang=js"

import "./PlanesComponent.vue?vue&type=style&index=0&id=6036f126&scoped=true&lang=css"

import exportComponent from "D:\\GIT\\DevOps\\Planner\\FRONT_Planner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6036f126"]])

export default __exports__